import { Component, Input } from '@angular/core';
import { formatForApi } from 'netsocial-lib/src/app/utils/date-utils';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';
import {
  Export,
  ExportFormat,
  GetStatsExportParams,
  ReportingService,
} from '../../../services/reporting/reporting.service';
import { ChangeFiltersOutput } from '../analytics-header/analytics-header.component';

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
})
export class ExportDialogComponent {
  public modal: HTMLIonModalElement;

  @Input() startDate: Date;
  @Input() endDate: Date;

  @Input() startDateCompare?: Date;
  @Input() endDateCompare?: Date;

  @Input() compareResults?: boolean;
  @Input() filterBy?: GetStatsExportParams['view'];
  @Input() socials?: string[];
  @Input() comparison?: string;
  @Input() teamIds: GetStatsExportParams['teamIds'];

  constructor(private reportingService: ReportingService, private errorService: ErrorService) {}

  public csvChecked = true;
  public emailChecked: boolean;
  public excelChecked: boolean;

  public exportPromise: Promise<(Export | undefined)[]>;

  changeFilters(output: ChangeFiltersOutput) {
    this.startDate = output.start;
    this.endDate = output.end;

    this.startDateCompare = output.startCompare;
    this.endDateCompare = output.endCompare;
    this.compareResults = output.compareResults;
    this.filterBy = output.filterBy;
    this.socials = output.socials;
    this.comparison = output.comparison;
    this.teamIds = output.teamIds;
  }

  async export() {
    const exports: ExportFormat[] = [];

    if (this.csvChecked) {
      exports.push('csv');
    }

    if (this.emailChecked) {
      exports.push('email');
    }

    if (this.excelChecked) {
      exports.push('excel');
    }

    const promises = exports.map((format) => {
      const params: GetStatsExportParams = {
        startDate: formatForApi(this.startDate),
        endDate: formatForApi(this.endDate),
        format,
        view: this.filterBy,
      };

      if (this.compareResults && this.startDateCompare && this.endDateCompare) {
        params.compare = 1;
        params.compareMethod = 'custom';
        params.compareStartDate = formatForApi(this.startDateCompare);
        params.compareEndDate = formatForApi(this.endDateCompare);
      }

      if (this.teamIds) {
        params.teamIds = this.teamIds;
      }

      if (this.socials?.length) {
        params.accountService = this.socials;
      }

      return this.errorService.resolve(this.reportingService.getStatsExport(params));
    });
    const exportPromise = Promise.all(promises);
    this.exportPromise = exportPromise;

    await exportPromise;

    return this.modal.dismiss();
  }
}
